import { openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import { SampleSlice } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";

export function AnapathSampleSliceForm({
  current,
  isSimplified,
  onChange,
}: {
  current?: SampleSlice;
  isSimplified?: boolean;
  onChange: (newValue: SampleSlice) => void;
}) {
  let [data, setData] = useState(current || ({} as SampleSlice));
  function setNewValue(newValue: SampleSlice) {
    setData(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid c1 gap10">
      <Input
        name="Code barre"
        value={data.barcode}
        type="text"
        placeholder="Texte libre..."
        onChange={(newValue) => {
          setNewValue({ ...data, barcode: newValue });
        }}
      />
      <Input
        name="Notes"
        value={data.notes}
        shouldFocus={true}
        type="textarea"
        rows={5}
        placeholder="Texte libre..."
        onChange={(newValue) => {
          setNewValue({ ...data, notes: newValue });
        }}
      />
      <Input
        name="Conclusion"
        value={data.conclusion}
        type="textarea"
        placeholder="Texte libre..."
        rows={8}
        onChange={(newValue) => {
          setNewValue({ ...data, conclusion: newValue });
        }}
      />
      <div></div>
      <div></div>
      <Input
        name="Pièces jointes"
        value={data.uploads}
        type="uploads"
        onChange={(newValue) => {
          setNewValue({ ...data, uploads: newValue });
        }}
      />
    </div>
  );
}

export function openAnapathSampleSliceForm({
  sampleSlice,
  isSimplified,
  onSave,
}: {
  sampleSlice: SampleSlice;
  isSimplified?: boolean;
  onSave: (sampleSlice: SampleSlice) => void;
}) {
  openDrawer({
    id: "anapathSampleSliceForm",
    title: "Pièce / Prélèvement",
    content: (
      <AnapathSampleSliceForm
        current={sampleSlice}
        isSimplified={isSimplified}
        onChange={(newValue) => {
          sampleSlice = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      sampleSlice = await apiFetch("sampleSlices", "addOne", {
        sampleSlice,
      });
      onSave(sampleSlice);
    },
  });
}
